//@ts-check

// External
import React, { useEffect, useLayoutEffect } from "react"
import _ from "lodash"
import Hidden from "@material-ui/core/Hidden"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import Box from "@material-ui/core/Box"
import { useTranslation } from "react-i18next"
import ListIcon from "@material-ui/icons/List"	
import PolicyIcon from "@material-ui/icons/Policy"
import clsx from "clsx"

// Internal
import useStyles from "./input-method-selection.styles"
import Button from "../button"
import EnterETHAddress from "./enter-eth-address"

/**
 * @param props{{
 * onInputTypeSelected
 * inputMethod
 * inputMethodSection
 * inputMethodWidth
 * setInputMethodWidth
 * setCode
 * inputAddress
 * setInputAddress
 * chosenToken
 * setChosenToken
 * setCompilerVersion
 * loading_solidity_state
 * setLoadingSolidityState
 * mainnetRequestState
 * setMainnetRequestState
 * }}
 */
export default function InputMethodSelection({
  onInputTypeSelected,
  inputMethod,
  inputMethodSection,
  setInputMethodWidth,
  inputMethodWidth,
  setCode,
  inputAddress,
  setInputAddress,
  chosenToken,
  setChosenToken,
  setCompilerVersion,
  loading_solidity_state,
  setLoadingSolidityState,
  mainnetRequestState,
  setMainnetRequestState,
}) {

  const { t } = useTranslation()
  // State

  // Effects
  useEffect(() => {
    setInputMethodWidth(inputMethodSection.current?.offsetWidth)
  }, [inputMethodSection.current?.offsetWidth])

  useLayoutEffect(() => {
    if (inputMethodSection) {
      const measure = () =>
        window.requestAnimationFrame(() => {
          if (inputMethodSection.current) {
            setInputMethodWidth(inputMethodSection.current.offsetWidth)
          }
        })
      measure()

      window.addEventListener("resize", measure)

      return () => {
        window.removeEventListener("resize", measure)
      }
    }
  }, [inputMethodSection])

  // Variables
  /** @type {any} */
  const classes = useStyles({})

  // Variables
  const selectSourceOptions = [
    {
      id: "code",
      label: t("enter_edit_source_code"),
    },
    {
      id: "token",
      label: t("select_from_list_of_tokens"),
      icon: <ListIcon />,	
    },
    {
      id: "mainnet",
      label: t("extract_from_mainnet_address"),
      icon: <PolicyIcon />,	
    },
  ]
  return (
    <>
      <Hidden xsDown>
        <Box className={classes.buttonWrapper}>
          <div ref={inputMethodSection}>
          {selectSourceOptions.map((item, index) => {
            if (item.id === "code") {
              return null
            }
            return (
              <Button
                className={clsx({[classes.buttonNotLast]: index !== selectSourceOptions.length - 1})}
                variant="outlined"
                color="primary"
                size="small"
                key={item.id}
                onClick={(event) => onInputTypeSelected(item.id, event)}
                startIcon={item.icon}
                id={`inputSelectionButton-${item.id}`}
              >
                {item.label}
              </Button>
            )
          })}
          </div>
        </Box>
      </Hidden>
      <Hidden smUp>
        <Select
          className={classes.tokenSelection}
          id="input-method-select"
          onChange={e => onInputTypeSelected(e.target.value)}
          variant="outlined"
          value={inputMethod}
        >
          {selectSourceOptions.map(option => (
            <MenuItem key={option.id} value={option.id}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        <div className={classes.inputCodeWrapper}>
          <div
            style={{
              maxWidth: inputMethodWidth > 0 ? inputMethodWidth : "unset",
            }}
          >
            {(inputMethod === "token" || inputMethod === "mainnet") && (
              <EnterETHAddress
                onChange={() => { }}
                inputMethod={inputMethod}
                setCode={setCode}
                inputAddress={inputAddress}
                setInputAddress={setInputAddress}
                chosenToken={chosenToken}
                setChosenToken={setChosenToken}
                setCompilerVersion={setCompilerVersion}
                loading_solidity_state={loading_solidity_state}
                setLoadingSolidityState={setLoadingSolidityState}
                mainnetRequestState={mainnetRequestState}
                setMainnetRequestState={setMainnetRequestState}
                isAutoSubmit={true}
                isInPopover={false}
              />
            )}
          </div>
          {inputMethod === "code" && (
            <div className={classes.subTitleText}>
              <span>{t("you_can_also_directly")}</span>
              <strong>{t("copy_and_paste_and_edit")}</strong>
              <span>{t("your_code_below")}</span>
            </div>
          )}
        </div>
      </Hidden>
    </>
  )
}
